// 组件
import SimpleForm, { SimpleFormItemProps } from "../../SimpleForm";
// 方法
import { getInputPlaceholder } from "../../utils/ruleUtils";
// 常量
import { EditDynamicSubTableColumnType } from "../interface";

function getFormItem(record: any, props: EditDynamicSubTableColumnType) {
  const {
    label,
    name,
    form,
    initialValue,
    formItemType,
    inputProps,
    inputNumberProps,
  } = props;
  const baseSearchFormProps: SimpleFormItemProps = { name, initialValue, form, };
  const baseFormProps = {};
  switch (formItemType) {
    case 'Input':
      return (
        <SimpleForm.Input
          {...baseSearchFormProps}
          inputProps={{
            ...baseFormProps,
            ...inputProps,
            placeholder: getInputPlaceholder(label, inputProps, baseSearchFormProps?.rules),
          }}
        />
      );
    case 'InputNumber':
      return (
        <SimpleForm.InputNumber
          {...baseSearchFormProps}
          inputNumberProps={{
            ...baseFormProps,
            ...inputNumberProps,
            placeholder: getInputPlaceholder(label, inputNumberProps, baseSearchFormProps?.rules),
          }}
        />
      );
  }
}

export default getFormItem;
